import loadable from "@loadable/component";
import React, { useRef } from "react";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import ReactModal from "react-modal";

export const Modal = loadable(() =>
    import(
        /* webpackChunkName: "react-modal" */
        "react-modal"
    )
);

interface LazyModalProps extends ReactModal.Props {
    children: React.ReactNode;
    noScroll?: boolean;
}

function LazyModal({
    isOpen,
    noScroll = true,
    children,
    ...props
}: LazyModalProps): React.ReactElement | null {
    const contentRef = useRef<HTMLDivElement>(null);

    if (!isOpen) {
        return null;
    }

    function onAfterOpen(): void {
        if (noScroll) {
            disableBodyScroll(contentRef.current);
        }
        props.onAfterOpen?.();
    }

    function onAfterClose(): void {
        if (noScroll) {
            enableBodyScroll(contentRef.current);
        }
        props.onAfterClose?.();
    }

    return (
        <Modal {...props} isOpen={isOpen} onAfterOpen={onAfterOpen} onAfterClose={onAfterClose}>
            <div ref={contentRef}>{children}</div>
        </Modal>
    );
}

export default LazyModal;
